// extracted by mini-css-extract-plugin
module.exports = {"toggler":"LanguageSwitcherDesktop_toggler__Uvy9Y"};